import { Cloud } from '@silbo/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import toast from '../../../../toast';

type AcceptRequestParams = { id: string; startAt: Date; bedId?: string };

export const useAcceptRequestMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: unknown, variables: AcceptRequestParams) => void;
  onError?: (error: unknown, variables: AcceptRequestParams) => void;
} = {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('bed-management');

  const mutation = useMutation({
    mutationFn: async ({ id, startAt, bedId }: AcceptRequestParams) => {
      return await Cloud.acceptPerformerRequest({ id, startAt, bedId });
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['requests'] });
      toast.success(t('requestDetails.actions.accept.successToast'));
      onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Failed to accept accommodation request:', error);
      toast.error(t('requestDetails.actions.accept.errorToast'));
      onError?.(error, variables);
    },
  });

  return {
    acceptRequest: mutation.mutateAsync,
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
